import { VERSION_INPUT_TYPE } from "./types";

export const VERSION_INPUT_DICTIONARY = {
  [VERSION_INPUT_TYPE.RANGE]: "Range",
  [VERSION_INPUT_TYPE.SPECIFIC]: "Specific",
};
